import request from '@/utils/request';
// 下载列表
export function getDownLoadList(params) {
  return request({
    url: '/user/user-download/list',
    method: 'get',
    params: params
  });
}
// 下载
export function userDownLoad(params) {
  return request({
    url: '/user/user-download/download',
    method: 'get',
    params: params
  });
}
// 搜索条件
export function userDownLoadSearch(params) {
  return request({
    url: '/user/user-download/get-search',
    method: 'get',
    params: params
  });
}
// 平台下载中心-删除记录
export function delRecord(data) {
  return request({
    url: '/user/user-download/del-my-record',
    method: 'post',
    data: data
  });
}
// 炮火雷达-职能部门分工列表
export function getArtilleryRadar(params) {
  return request({
    url: '/orders/organize-work-item/index-to-artillery-radar',
    method: 'get',
    params: params
  });
}
//  炮火雷 提反馈
export function createFeedback(data) {
  return request({
    url: '/orders/organize-work-feedback/create',
    method: 'post',
    data: data
  });
}
//  炮火雷 点击“有用”
export function createEvaluationFeedback(data) {
  return request({
    url: '/orders/organize-work-item-evaluation/create',
    method: 'post',
    data: data
  });
}
// 炮火雷达-职能部门分工列表
export function getMyFeedback(params) {
  return request({
    url: '/orders/organize-work-feedback/my-feedback',
    method: 'get',
    params: params
  });
}